// Shared signal so IOSInstallBanner can hide while PWAInstallPrompt's hero
// modal is open, then reappear automatically once the modal closes.
//
// Why a tiny pub/sub instead of a context: both components are mounted in
// completely different parts of the tree (App.tsx vs. ClientLayout/CoachLayout)
// and adding a Provider just to share one boolean isn't worth the wiring.

let modalOpen = false;
const subscribers = new Set<(open: boolean) => void>();

export function setPWAInstallModalOpen(open: boolean): void {
  if (modalOpen === open) return;
  modalOpen = open;
  subscribers.forEach((fn) => fn(open));
}

export function isPWAInstallModalOpen(): boolean {
  return modalOpen;
}

export function subscribePWAInstallModal(fn: (open: boolean) => void): () => void {
  subscribers.add(fn);
  return () => {
    subscribers.delete(fn);
  };
}
